import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
export const StatisticsCardSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="mx-20 mb-20 flex h-80 items-center gap-12 rounded-medium bg-Gray-white p-8">{[1, 2, 3, 4].map(_temp)}</section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(index) {
  return <div key={index} className="group flex flex-1 flex-col items-center justify-center gap-2 rounded-medium py-8" style={{
    animation: "pulse 1s cubic-bezier(0.4, 0, 0.6, 1) infinite",
    animationDelay: `${index * 150}ms`
  }}><Skeleton className="h-12 w-60 rounded-small mobile-sm:h-10" /><Skeleton className="h-16 w-50 rounded-small mobile-sm:h-12" /></div>;
}